/** Referral: $22 from referrer Wallet (held) → $22 off referee's first membership invoice. */

export const REFERRAL_HOLD_CENTS = 2200;
export const REFERRAL_DISCOUNT_CENTS = 2200;
export const REFERRAL_CODES_COLLECTION = 'referral_codes';

export function formatReferralLink(origin, code) {
  const base = String(origin || '').replace(/\/$/, '');
  const c = String(code || '').trim();
  if (!base || !c) return '';
  return `${base}/plans?ref=${encodeURIComponent(c)}`;
}
